import { FileDown } from 'lucide-react';
import { useState } from 'react';
import { toast } from 'sonner';

import { mensajeDe } from '@/api/errors';
import { guardarArchivo } from '@/lib/descargar';

/** Botón que pide un archivo a la API (`parseAs: 'blob'`) y lo guarda. */
export function BotonDescarga({
  etiqueta,
  nombre,
  pedir,
  className = 'btn-cs btn-vidrio',
}: {
  etiqueta: string;
  nombre: string;
  pedir: () => Promise<{ data?: Blob; error?: unknown; response: Response }>;
  className?: string;
}) {
  const [ocupado, setOcupado] = useState(false);
  return (
    <button
      type="button"
      className={className}
      disabled={ocupado}
      onClick={() => {
        setOcupado(true);
        void pedir()
          .then((r) => guardarArchivo(r, nombre))
          .catch((e: unknown) => toast.error(mensajeDe(e)))
          .finally(() => setOcupado(false));
      }}
    >
      <FileDown size={16} aria-hidden /> {ocupado ? 'Generando…' : etiqueta}
    </button>
  );
}
